/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Grid_View_TitleInputs */

const en_speakers_grid_view_title = /** @type {(inputs: Speakers_Grid_View_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grid view`)
};

const fr_speakers_grid_view_title = /** @type {(inputs: Speakers_Grid_View_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vue en grille`)
};

const de_speakers_grid_view_title = /** @type {(inputs: Speakers_Grid_View_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rasteransicht`)
};

const it_speakers_grid_view_title = /** @type {(inputs: Speakers_Grid_View_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualizzazione griglia`)
};

const ru_speakers_grid_view_title = /** @type {(inputs: Speakers_Grid_View_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сеточный вид`)
};

const es_speakers_grid_view_title = /** @type {(inputs: Speakers_Grid_View_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vista de cuadrícula`)
};

const zh_cn2_speakers_grid_view_title = /** @type {(inputs: Speakers_Grid_View_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`网格视图`)
};

const ja_speakers_grid_view_title = /** @type {(inputs: Speakers_Grid_View_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グリッドビュー`)
};

const hi_speakers_grid_view_title = /** @type {(inputs: Speakers_Grid_View_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जालक दृश्य`)
};

const pt_pt2_speakers_grid_view_title = /** @type {(inputs: Speakers_Grid_View_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualização em grade`)
};

/**
* | output |
* | --- |
* | "Grid view" |
*
* @param {Speakers_Grid_View_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_grid_view_title = /** @type {((inputs?: Speakers_Grid_View_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Grid_View_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speakers_grid_view_title(inputs)
	if (locale === "de") return de_speakers_grid_view_title(inputs)
	if (locale === "it") return it_speakers_grid_view_title(inputs)
	if (locale === "ru") return ru_speakers_grid_view_title(inputs)
	if (locale === "es") return es_speakers_grid_view_title(inputs)
	if (locale === "zh-CN") return zh_cn2_speakers_grid_view_title(inputs)
	if (locale === "ja") return ja_speakers_grid_view_title(inputs)
	if (locale === "hi") return hi_speakers_grid_view_title(inputs)
	if (locale === "pt-PT") return pt_pt2_speakers_grid_view_title(inputs)
	return en_speakers_grid_view_title(inputs)
});